import {createMessageId} from './createMessageId';
import type {ChatMessage, PendingChatAttachment} from './types';

export function isImageFile(file: File) {
    return file.type.startsWith('image/');
}

function createMessageAttachment({file, previewUrl}: PendingChatAttachment) {
    const isImage = isImageFile(file);

    return {
        name: file.name,
        kind: isImage ? 'image' as const : 'file' as const,
        previewUrl: isImage ? previewUrl : '',
    };
}

export function revokeMessageAttachmentUrls(messages: ChatMessage[]) {
    messages.forEach(message => {
        if(message.role === 'user' && message.attachment?.previewUrl) {
            URL.revokeObjectURL(message.attachment.previewUrl);
        }
    });
}

export function buildUserMessage(text: string, pendingAttachment?: PendingChatAttachment | null) {
    return {
        role: 'user' as const,
        text,
        id: createMessageId(),
        ...(pendingAttachment ? {attachment: createMessageAttachment(pendingAttachment)} : {}),
    };
}

export function canSubmitPrompt(text: string, pendingAttachment?: PendingChatAttachment | null) {
    return Boolean(text.trim() || pendingAttachment);
}
